import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useBBoxObserver } from '../hooks/useBBoxObserver';
function calculatePosition(start, align, space) {
    switch (align) {
        case 'start': {
            return start;
        }
        case 'end': {
            return start - space;
        }
        case 'middle': {
            return start - space / 2;
        }
        default: {
            throw new Error(`Unkwnown alignment ${JSON.stringify(align)}`);
        }
    }
}
export function AlignGroup(props) {
    const { x = 0, y = 0, verticalAlign = 'start', horizontalAlign = 'start', children, } = props;
    const observed = useBBoxObserver();
    const xPosition = useMemo(() => calculatePosition(x - observed.x, horizontalAlign, observed.width || 0), [x, horizontalAlign, observed.x, observed.width]);
    const yPosition = useMemo(() => calculatePosition(y - observed.y, verticalAlign, observed.height || 0), [y, verticalAlign, observed.y, observed.height]);
    return (_jsx("g", Object.assign({ ref: observed.ref, transform: `translate(${xPosition}, ${yPosition})` }, { children: children }), void 0));
}
//# sourceMappingURL=AlignGroup.js.map